import React, {useEffect, useState} from "react";
import axiosInstance from "../../../api/api";
import {Spinner} from "@themesberg/react-bootstrap";
import {Alert, Button, Col, Form, Modal, Row, Table} from "react-bootstrap";
import TextWhitTooltip from "../Util/TextWhitTooltip";
import CurrencyInput from "../Util/CurrencyInput";

const TableVertical = ({ optionName, ciemId, editable }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [tableHeaders, setTableHeaders] = useState([]);
    const [editData, setEditData] = useState({});
    const [error, setError] = useState(null);

    useEffect(() => {
        //inicializar();
        fetchTableList();
    }, []);

    const fetchTableList = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get('/'+optionName+'/'+ciemId.ciemId); // <-- Ajusta esta ruta
            setData(response.data.data);
            setEditData(response.data.data);
            const tableHeader = await axiosInstance.get('/detailoption/option/value/'+optionName);

            // --- MODIFICACIÓN: Ordenar de mayor a menor por 'order' ---
            const sortedHeaders = tableHeader.data.data.sort((a, b) => a.orden - b.orden);
            console.log(sortedHeaders)
            setTableHeaders(sortedHeaders);
            // --- FIN DE MODIFICACIÓN ---

            console.log("tabla "+optionName)
            console.log(tableHeader)
        } catch (error) {
            console.error('Error al cargar:', error);
            alert('Error al cargar los datos');
        } finally {
            setLoading(false);
        }
    };

    /*
    const inicializar= async ()=>{
        try {
            await axiosInstance.post('/peu/inicializar/'+ciemId.ciemId); // <-- Ajusta esta ruta
            //setpeuList(response.data);
        } catch (error) {
            console.error('No se pudo inicializar:', error);
            alert('Error inicializando datos');
        } finally {
            setLoading(false);
        }
    }
        **/

    const handleChange = (key, value) => {
        setEditData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleSave = async () => {
        try {
            console.log(editData)
            await axiosInstance.post('/'+optionName+'/', editData); // <-- Ajusta esta ruta
            fetchTableList();
            alert('Guardado correctamente');
        } catch (error) {
            console.error('Error al guardar:', error);
            alert('Error al guardar los datos');
        }
    };


    if (loading) {
        return (
            <div className="text-center my-4">
                <Spinner animation="border" role="status" />
                <p>Cargando información...</p>
            </div>
        );
    }

    if (error) {
        return <Alert variant="danger">{error}</Alert>;
    }

    if (!data) {
        return <Alert variant="warning">No se encontró información.</Alert>;
    }


    return (
        <card>
            <Table bordered striped hover>
                <thead>
                <tr>
                    <th>Descripción</th>
                    <th>Valor</th>
                </tr>
                </thead>
                <tbody>
                {/* Iterar sobre tableHeaders (ya ordenado) */}
                {tableHeaders.map((header) => {
                    const key = header.value;

                    // Asegurarse de que el dato exista en editData antes de renderizar
                    if (editData[key] === undefined) {
                        return null;
                    }

                    const item = editData[key];

                    return (
                        <tr key={header.value}> {/* Usar una key más estable que el index */}
                            <td style={{ width: "50%" }}>
                                <div style={{
                                    width: "100%",
                                    overflowWrap: "break-word",   // permite cortar palabras largas
                                    whiteSpace: "normal"          // permite saltos de línea
                                }}>
                                    <TextWhitTooltip value={header.description} detail={header} />
                                </div>
                            </td>
                            <td style={{ width: "50%" }}>
                                <CurrencyInput
                                    type={header.type === "number" ? "number" : "text"}
                                    value={item}
                                    name={key}
                                    onChange={(e) =>
                                        handleChange(e.target.name, e.target.value)
                                    }
                                    readOnly={!header.editable}
                                    title={header.tooltip || ""}
                                />
                            </td>
                        </tr>
                    );
                })}
                </tbody>
            </Table>

            {editable && (
                <Row className="mt-3">
                    <Col className="text-end">
                        <Button variant="primary" onClick={handleSave}>
                            Guardar Cambios
                        </Button>
                    </Col>
                </Row>
            )}
        </card>
    );
};

export default TableVertical;